<script>
    export let fill = '#FFF'
</script>

<style>
    svg#team-info-selector {
        position: absolute;
        width: 117.75px;
        height: 31.81px;
        top: 95px;
        left: 12px;
    }
</style>

<svg id="team-info-selector" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 117.75 31.81">
    <g id="Layer_2" data-name="Layer 2">
        <g id="Layer_1-2" data-name="Layer 1">
            <rect {fill} width="117.75" height="31.81" rx="15.91" />
        </g>
    </g>
</svg>
